window.get_room_category = function () {
  var placeholder_category = $('#placeholder-category').data('placeholder');
  $('#placeholder-category').text(placeholder_category);
  $("#modal-rooms").find("tbody tr").off('click').on('click', function () {
    $this = $(this).find('input');
    var category = $this.data('category');
    var customFieldId = $('#tab-overflow').data('customFieldId');
    $('#placeholder-category-' + customFieldId).text(category);
    $('#input-chamber-' + customFieldId).val(category);
  });
  $(document).find(".modal-button").off('click').on('click', function () {
    var customFieldId = $(this).data('customFieldId');
    $('#tab-overflow').data('customFieldId', customFieldId);
  });
}
